import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer data-name="footer" className="bg-gray-900 text-white py-16 relative overflow-hidden">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8 relative z-10">
                    <div className="md:col-span-4">
                        <div className="mb-6">
                            <Link to="/">
                                <img 
                                    src="https://app.trickle.so/storage/public/images/usr_0e1b4a1e10000001/7c5c3bb9-183f-4ed1-a770-691d10a86be1.png" 
                                    alt="Sustainable Computing Network Logo"
                                    className="h-10"
                                />
                            </Link>
                        </div>
                        <p className="text-gray-400 mb-6 max-w-md">
                            Transforming electronic waste into sustainable computing solutions for educational institutions worldwide, powered by renewable energy.
                        </p>
                        <div className="flex space-x-4">
                            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 hover:bg-green-600 flex items-center justify-center transition-colors duration-300">
                                <i className="fab fa-twitter text-white"></i>
                            </a>
                            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 hover:bg-green-600 flex items-center justify-center transition-colors duration-300">
                                <i className="fab fa-linkedin-in text-white"></i>
                            </a>
                            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 hover:bg-green-600 flex items-center justify-center transition-colors duration-300">
                                <i className="fab fa-github text-white"></i>
                            </a>
                        </div>
                    </div>
                    
                    <div className="md:col-span-2">
                        <h3 className="text-lg font-semibold mb-4 text-white">About</h3>
                        <ul className="space-y-2">
                            <li><Link to="/mission" className="text-gray-400 hover:text-green-400 transition-colors">Our Mission</Link></li>
                            <li><Link to="/team" className="text-gray-400 hover:text-green-400 transition-colors">Team</Link></li>
                            <li><Link to="/partners" className="text-gray-400 hover:text-green-400 transition-colors">Partners</Link></li>
                            <li><Link to="/impact" className="text-gray-400 hover:text-green-400 transition-colors">Impact</Link></li>
                        </ul>
                    </div>
                    
                    <div className="md:col-span-2">
                        <h3 className="text-lg font-semibold mb-4 text-white">Get Involved</h3>
                        <ul className="space-y-2">
                            <li><Link to="/donate" className="text-gray-400 hover:text-green-400 transition-colors">Donate Hardware</Link></li>
                            <li><Link to="/volunteer" className="text-gray-400 hover:text-green-400 transition-colors">Volunteer</Link></li>
                            <li><Link to="/partner" className="text-gray-400 hover:text-green-400 transition-colors">Partner With Us</Link></li>
                            <li><Link to="/support" className="text-gray-400 hover:text-green-400 transition-colors">Support Our Work</Link></li>
                        </ul>
                    </div>
                    
                    <div className="md:col-span-2">
                        <h3 className="text-lg font-semibold mb-4 text-white">Resources</h3>
                        <ul className="space-y-2">
                            <li><Link to="/blog" className="text-gray-400 hover:text-green-400 transition-colors">Blog</Link></li>
                            <li><Link to="/case-studies" className="text-gray-400 hover:text-green-400 transition-colors">Case Studies</Link></li>
                            <li><Link to="/impact-reports" className="text-gray-400 hover:text-green-400 transition-colors">Impact Reports</Link></li>
                            <li><Link to="/faq" className="text-gray-400 hover:text-green-400 transition-colors">FAQ</Link></li>
                        </ul>
                    </div>
                    
                    <div className="md:col-span-2">
                        <h3 className="text-lg font-semibold mb-4 text-white">Contact</h3>
                        <ul className="space-y-2">
                            <li className="flex items-center text-gray-400">
                                <i className="fas fa-envelope mr-2 text-green-400"></i>
                                info@sustainablecomputenetwork.org
                            </li>
                            <li className="flex items-center text-gray-400">
                                <i className="fas fa-map-marker-alt mr-2 text-green-400"></i>
                                London, United Kingdom
                            </li>
                            <li className="mt-4">
                                <Link to="/contact" className="text-green-400 hover:text-green-300 flex items-center">
                                    <i className="fas fa-paper-plane mr-2"></i>
                                    Contact Us
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                
                <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
                    <p className="text-gray-500 text-sm">&copy; {new Date().getFullYear()} Sustainable Compute Network. All rights reserved.</p>
                    <div className="mt-4 md:mt-0 flex space-x-6">
                        <Link to="/privacy-policy" className="text-gray-500 hover:text-green-400 text-sm">Privacy Policy</Link>
                        <Link to="/terms-of-service" className="text-gray-500 hover:text-green-400 text-sm">Terms of Service</Link>
                        <Link to="/cookie-policy" className="text-gray-500 hover:text-green-400 text-sm">Cookie Policy</Link>
                    </div>
                </div>
            </div>
            
            {/* Background elements */}
            <div className="absolute inset-0 -z-10">
                <div className="circuit-grid"></div>
            </div>
            
            {/* Floating particles */}
            <div className="absolute top-0 left-0 w-full h-full opacity-10">
                {Array.from({ length: 20 }).map((_, i) => (
                    <div 
                        key={i}
                        className="absolute rounded-full bg-green-400"
                        style={{
                            width: `${Math.random() * 10 + 5}px`,
                            height: `${Math.random() * 10 + 5}px`,
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                            animation: `float ${Math.random() * 10 + 5}s linear infinite`,
                            animationDelay: `${Math.random() * 5}s`
                        }}
                    ></div>
                ))}
            </div>
        </footer>
    );
}

export default Footer;
